import { useEffect } from 'react'
import { GlobalState } from '@leverege/ui-redux'
import { useSelector } from 'react-redux'
import Constants from '../../../util/Constants'

export default function useBBoxes( props ) {
  const { delegate, range } = props

  const result = useSelector( ( state ) => {
    return delegate.eventsDelegate.getList( state, range.name, { getAll : true } )
  } )

  useEffect( () => {
    GlobalState.dispatch(
      delegate.eventsDelegate.search( {
        query : {
          start : range.start,
          end : range.end,
          where : [
            [ '$data/analyticsType', '=', 'detection' ]
          ],
          paths : [
            [ 'doesnt/matter', 'x', {
              function : '/',
              args : [
                {
                  function : '*',
                  args : [
                    {
                      function : '+',
                      args : [
                        {
                          function : '/',
                          args : [
                            { type : 'field', value : [ 'extraData/detection/objectBBox/width', null, null, 'integer' ] },
                            2
                          ]
                        },
                        { type : 'field', value : [ 'extraData/detection/objectBBox/left', null, null, 'integer' ] }
                      ]
                    },
                    Constants.GRID_SIZE.width,
                  ]
                },
                Constants.HEATMAP_IMAGE_SIZE.original.width
              ]
            } ],
            [ 'also/doesnt/matter', 'y', {
              function : '/',
              args : [
                {
                  function : '*',
                  args : [
                    {
                      function : '+',
                      args : [
                        { type : 'field', value : [ 'extraData/detection/objectBBox/height', null, null, 'integer' ] },
                        { type : 'field', value : [ 'extraData/detection/objectBBox/top', null, null, 'integer' ] }
                      ]
                    },
                    Constants.GRID_SIZE.height,
                  ]
                },
                Constants.HEATMAP_IMAGE_SIZE.original.height
              ]
            } ],
            [ '$id', 'value', { function : 'COUNT' } ],
          ],
          group : [ 'x', 'y' ]
        },
        queryName : range.name
      } )
    )
  }, [ delegate, range ] )

  return {
    result
  }
}
